export default __webpack_public_path__ + "static/media/463.1eaa43c7.png";